import { Component, Injector } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { CtaDesktopComponent } from '../../sharedComponent/cta-component/cta-desktop/cta-desktop.component';
import { DownloadpdfDesktopComponent } from '../../sharedComponent/downloadpdf-component/downloadpdf-desktop/downloadpdf-desktop.component';
import { Pages } from '../../../models/blog.model';
import { TranslateService } from '@ngx-translate/core'


@Component({
  selector: 'flowaccount-guide-content',
  templateUrl: './guide-content.component.html',
  styleUrls: ['./guide-content.component.scss'],
})
export class GuideContentComponent {
  page = Pages
  constructor(public translate: TranslateService, injector: Injector) {
    // Register the custom element with the browser.
    if (!customElements.get('downloadpdf-desktop-element')) {
      const PopupElement = createCustomElement(DownloadpdfDesktopComponent, { injector })
      customElements.define('downloadpdf-desktop-element', PopupElement)
    }
    if (!customElements.get('cta-desktop-element')) {
      const PopupElement2 = createCustomElement(CtaDesktopComponent, { injector })
      customElements.define('cta-desktop-element', PopupElement2)
    }
  }
}
